module.exports = __webpack_public_path__ + "img/wancheng_bg.36d90544.png";